<script setup>
import { computed } from 'vue';

const props = defineProps({
	item: {
		type: Object,
	},
});

const image = computed(() => {
	return props.item?.img?.sizes?.large;
});
</script>

<template>
	<li class="c-card" :class="{ 'c-card--document': !image }">
		<div class="c-card__link">
			<div class="c-card__img" v-if="image">
				<span class="img img--cover">
					<img :src="image" alt="media.title" />
				</span>
			</div>
			<div class="c-card__info">
				<div class="c-card__tags">
					<span class="f-tag">{{ item.date ?? '' }}</span>
				</div>
				<h4 class="c-card__heading heading-sm">{{ item.title ?? '' }}</h4>
				<a class="c-button c-button--link" :href="item.url" download v-if="item.url">
					<svg class="icon icon-download">
						<use xlink:href="#icon-download"></use>
					</svg>
					Download
				</a>
			</div>
		</div>
	</li>
</template>
